// 点击Studio名，支持跳转系统的映射
export enum StudioJumpSystem {
  // GPOP
  GPop = '1',
  // 情报
  Intelligence = '2',
}
